const CURRENCIES = {
  'en-US': 'USD',
  'el-GR': 'EUR',
  'en-GB': 'GBP',
  'de-DE': 'EUR'
};

export function getLocale() {
  return (navigator && navigator.language) || 'en-US';
}

export function getCurrency() {
  return CURRENCIES[getLocale()] || 'EUR';
}

let formatter = null;
let formatterFor = null;
export default (number: number = 0, { settings = {} as any } = {}) => {
  const { locale = getLocale(), currency = getCurrency(), shuffle = false } = settings;
  if (!formatter || formatterFor !== `${locale}_${currency}`) {
    if ((window as any).Intl) {
      formatter = new Intl.NumberFormat(locale, { currency, style: 'currency' });
    } else {
      formatter = { format: x => x };
    }
    formatterFor = `${locale}_${currency}`;
  }

  if (shuffle) {
    return formatter.format(Math.random() * 10);
  }

  return formatter.format(number);
};



// WEBPACK FOOTER //
// ./src/services/format.currency.ts